module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../axios/index.js
// module id = 1370
// module chunks = 22